import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { isValidStored } from '../_helpers/storage.util';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {
    window.scroll(0,0);

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      var mm:any =(state.url).split('/');
      var url :any = '/'+ mm[1];
      if(url.includes('?')){
        var s:any=url.split('?');
        url=s[0];
      }
      let loginStatus: boolean = false;
      if (isValidStored('grw_login')) {
        loginStatus = true;
      } 
      if (url === '/' || url === '/signup' || url === '/signin' || url === '/forgot-password' || url === '/reset-password' || url === '/verify-email'  || url === '/verify-email-mobile') {
        if (loginStatus) {
          this.router.navigate(['/dashboard']);
        }
      } else {
        if (!loginStatus) {
          this.router.navigate(['/signin']);
        }
      }
      window.scroll(0,0);
    return true;
  }

}
